import JsonApi from "@/custolink-logic/api/JsonApi";


export enum AdmFilemanagerApi2$UiFileAiCreateEmbeddingJobInfoStatus { "Created" = "Created" , "Errored" = "Errored" , "NA" = "NA" , "Running" = "Running" , "Success" = "Success"};

export enum AdmFilemanagerApi2$UiFileAssetConditionType { "Custom" = "Custom" , "ProductName" = "ProductName" , "SerialNumber" = "SerialNumber"};

export enum AdmFilemanagerApi2$UiFileSearchFilter { "AiEligible" = "AiEligible" , "AiFailed" = "AiFailed" , "AiIndexed" = "AiIndexed" , "All" = "All" , "NoCategory" = "NoCategory" , "OwnCondition" = "OwnCondition"};

export interface AdmFilemanagerApi2$AiServiceFolderEnable {
    attributeConditioned: boolean;
    enable: boolean;
}

export interface AdmFilemanagerApi2$CreateFolder {
    folderName: string;
    ignoreExists: boolean;
}

export interface AdmFilemanagerApi2$CreateFolderResult {
    folderId: number;
}

export interface AdmFilemanagerApi2$FolderContents {
    files: AdmFilemanagerApi2$UiFileDto[];
    folders: AdmFilemanagerApi2$UiFolderDto[];
}

export interface AdmFilemanagerApi2$FolderOverviewResult {
    folders: { [key: number]: AdmFilemanagerApi2$UiFolderAggregate };
    home: AdmFilemanagerApi2$UiFolderAggregate;
}

export interface AdmFilemanagerApi2$FolderProtectionDetails {
    enabled: boolean;
    entries: AdmFilemanagerApi2$UiFolderProtectionEntryDto[];
    groupOptions: AdmFilemanagerApi2$UiProtectionGroupDto[];
    groups: AdmFilemanagerApi2$UiProtectionGroupDto[];
    inheritedFromPath: string | null;
    protectedDescendantPaths: string[];
}

export interface AdmFilemanagerApi2$FolderProtectionInput {
    enabled: boolean;
    entries: AdmFilemanagerApi2$UiFolderProtectionEntryDto[];
    groupIds: number[];
}

export interface AdmFilemanagerApi2$RagFileEnable {
    attributeConditioned: boolean;
    enable: boolean;
}

export interface AdmFilemanagerApi2$RenameInput {
    newName: string;
}

export interface AdmFilemanagerApi2$UiAiSupportedFileType {
    extension: string;
    label: string;
    mediaType: string;
}

export interface AdmFilemanagerApi2$UiAiSupportedFileTypes {
    fileTypes: AdmFilemanagerApi2$UiAiSupportedFileType[];
    helperText: string;
}

export interface AdmFilemanagerApi2$UiAiSupportedFileTypesResult {
    supportedFileTypes: AdmFilemanagerApi2$UiAiSupportedFileTypes | null;
}

export interface AdmFilemanagerApi2$UiFileAiCreateEmbeddingJobInfo {
    embeddingsAvailable: boolean;
    embeddingsShowInCstlnDataLink: string | null;
    status: AdmFilemanagerApi2$UiFileAiCreateEmbeddingJobInfoStatus;
}

export interface AdmFilemanagerApi2$UiFileAiDto {
    ancestorFolderAiAttributeConditioned: boolean;
    ancestorFolderAiEnabled: boolean;
    ancestorFolderAiPathEnabledPath: string;
    attributeConditioned: boolean;
    enable: boolean;
}

export interface AdmFilemanagerApi2$UiFileAssetCondition {
    expressions: AdmFilemanagerApi2$UiFileAssetConditionExpression[];
    internalOnly: boolean | null;
}

export interface AdmFilemanagerApi2$UiFileAssetConditionExpression {
    attributeName: string;
    attributeType: AdmFilemanagerApi2$UiFileAssetConditionType;
    attributeValue: string;
}

export interface AdmFilemanagerApi2$UiFileAssetInheritedCondition {
    expressions: AdmFilemanagerApi2$UiFileAssetConditionExpression[];
    prefixPath: string;
}

export interface AdmFilemanagerApi2$UiFileCategoryDto {
    id: number;
    name: string;
}

export interface AdmFilemanagerApi2$UiFileDetails {
    createdEpochMs: number | null;
    downloadBundles: AdmFilemanagerApi2$UiFileDownloadBundleUsage[];
    id: number;
    knowledgeRecords: AdmFilemanagerApi2$UiFileKnowledgeRecordUsage[];
    mimeType: string;
    name: string;
    relativePath: string;
    updatedEpochMs: number | null;
}

export interface AdmFilemanagerApi2$UiFileDownloadBundleUsage {
    assetId: number;
    assetProductname: string;
    assetSerialnumber: string;
    expired: boolean;
    expiresEpochMs: number;
    id: number;
    name: string;
}

export interface AdmFilemanagerApi2$UiFileDto {
    ai: AdmFilemanagerApi2$UiFileAiDto;
    aiCreateEmbeddingJobInfo: AdmFilemanagerApi2$UiFileAiCreateEmbeddingJobInfo | null;
    assetCondition: AdmFilemanagerApi2$UiFileAssetCondition;
    category: AdmFilemanagerApi2$UiFileCategoryDto | null;
    createdEpochMs: number | null;
    i18nVariantEnable: boolean;
    i18nVariantFamily: string;
    i18nVariantLanguageCode: string;
    id: number;
    inheritedConditions: AdmFilemanagerApi2$UiFileAssetInheritedCondition[];
    inheritedProtection: AdmFilemanagerApi2$UiFolderInheritedProtection | null;
    internalOnlyInheritedFrom: string | null;
    name: string;
    updatedEpochMs: number | null;
}

export interface AdmFilemanagerApi2$UiFileKnowledgeRecordUsage {
    callId: number;
    id: number;
    publishedEpochMs: number | null;
}

export interface AdmFilemanagerApi2$UiFileSearchHit {
    file: AdmFilemanagerApi2$UiFileDto;
    relativeFolderPath: string;
}

export interface AdmFilemanagerApi2$UiFileSearchResult {
    files: AdmFilemanagerApi2$UiFileSearchHit[];
    folders: AdmFilemanagerApi2$UiFolderSearchHit[];
    totalFiles: number;
    totalFolders: number;
    truncated: boolean;
}

export interface AdmFilemanagerApi2$UiFolderAggregate {
    aiEligibleFiles: number;
    aiFailedFiles: number;
    aiFileSourcesBelow: number;
    aiFolderSourcesBelow: number;
    aiIndexedFiles: number;
    fileCount: number;
    filesWithCondition: number;
    filesWithoutCategory: number;
    folderCount: number;
    foldersWithConditionBelow: number;
    ownAiAttributeConditioned: boolean;
    ownAiEnabled: boolean;
    ownHasCondition: boolean;
    ownProtected: boolean;
    protectedFoldersBelow: number;
}

export interface AdmFilemanagerApi2$UiFolderAiDto {
    ancestorFolderAiAttributeConditioned: boolean;
    ancestorFolderAiEnabled: boolean;
    ancestorFolderAiPathEnabledPath: string;
    attributeConditioned: boolean;
    enabled: boolean;
}

export interface AdmFilemanagerApi2$UiFolderDto {
    ai: AdmFilemanagerApi2$UiFolderAiDto;
    assetCondition: AdmFilemanagerApi2$UiFileAssetCondition;
    createdEpochMs: number | null;
    id: number;
    inheritedConditions: AdmFilemanagerApi2$UiFileAssetInheritedCondition[];
    inheritedProtection: AdmFilemanagerApi2$UiFolderInheritedProtection | null;
    internalOnlyInheritedFrom: string | null;
    name: string;
    path: string;
    protection: AdmFilemanagerApi2$UiFolderProtectionSummary | null;
    updatedEpochMs: number | null;
}

export interface AdmFilemanagerApi2$UiFolderInheritedProtection {
    path: string;
}

export interface AdmFilemanagerApi2$UiFolderProtectionEntryDto {
    emailOrDomain: string;
}

export interface AdmFilemanagerApi2$UiFolderProtectionSummary {
    entryCount: number;
    groupCount: number;
}

export interface AdmFilemanagerApi2$UiFolderSearchHit {
    folder: AdmFilemanagerApi2$UiFolderDto;
    relativeFolderPath: string;
}

export interface AdmFilemanagerApi2$UiProtectionGroupDto {
    id: number;
    name: string;
}

export interface AdmFilemanagerApiSuperadminTools$TextChunk {
    pages: string;
    text: string;
}

export interface AdmFilemanagerApiSuperadminTools$TextChunks {
    chunks: AdmFilemanagerApiSuperadminTools$TextChunk[];
}

export interface AdmFilemanagerApiTools$BulkCategorySet {
    categoryName: string;
    fileIds: number[];
}

export interface AdmFilemanagerOptionsApi$SetFileOptions {
    category: string | null;
    i18nVariantEnable: boolean;
    i18nVariantFamily: string;
    i18nVariantLanguageCode: string;
}

export interface AdmToolsAssetFilesTmpDownloadLinkApi$CreateDownloadLinkInput {
    assetFileIdsExcluded: number[];
    assetId: number;
    description: string;
    distributeManually: boolean;
    durationHours: number;
    name: string;
    recipients: AdmToolsAssetFilesTmpDownloadLinkApi$CreateDownloadLinkInputRecipient[];
    validateAsset: boolean;
    validateOnly: boolean;
    validateRecipientsSize: boolean;
}

export interface AdmToolsAssetFilesTmpDownloadLinkApi$CreateDownloadLinkInputRecipient {
    email: string;
    name: string;
}

export interface AdmToolsAssetFilesTmpDownloadLinkApi$HistoryEntry {
    asset: string;
    description: string;
    distributeManually: boolean;
    durationHours: number;
    expired: boolean;
    expiresAt: string;
    id: number;
    name: string;
    recipients: string[];
    url: string;
}

export interface CpCstlnDataApi$GetInfo {
    apiKeyIsSet: boolean;
    apiKeyLast4: string;
    baseUrl: string;
    collectionSlug: string;
    enabled: boolean;
    sourceSlug: string;
    transcriptionToolSlug: string;
}

export interface CpCstlnDataApi$GetOrganisations {
    organisations: CpCstlnDataApi$OrgRow[];
}

export interface CpCstlnDataApi$OrgRow {
    configured: boolean;
    enabled: boolean;
    name: string;
    orgId: number;
    webSlug: string;
}

export interface CpCstlnDataApi$SaveInfo {
    apiKey: string;
    baseUrl: string;
    collectionSlug: string;
    enabled: boolean;
    sourceSlug: string;
    transcriptionToolSlug: string;
}

export interface CpCstlnDataApi$TestConnectionInput {
    apiKey: string;
    baseUrl: string;
    collectionSlug: string;
    sourceSlug: string;
}

export interface CpCstlnDataApi$TestConnectionResult {
    message: string;
    ok: boolean;
}

export interface CpCstlnDataApi$TranscriptionToolOption {
    name: string;
    slug: string;
}

export interface CpCstlnDataApi$TranscriptionToolsInfo {
    selectedMissing: boolean;
    selectedSlug: string;
    tools: CpCstlnDataApi$TranscriptionToolOption[];
}

export interface FilemanagerSharedDefinitions$FileNode {
    category: string | null;
    id: number;
    name: string;
}

export interface FilemanagerSharedDefinitions$FolderNode {
    children: FilemanagerSharedDefinitions$FolderNode[];
    files: FilemanagerSharedDefinitions$FileNode[];
    id: number;
    idStrOverride: string | null;
    name: string;
    path: string;
}

export interface FilemanagerSharedDefinitions$FoldersAndFilesResult {
    fileCount: number;
    folderCount: number;
    rootFiles: FilemanagerSharedDefinitions$FileNode[];
    rootFolders: FilemanagerSharedDefinitions$FolderNode[];
}
export interface FrontendDownloadBundleApi$GetInfoForToken {
    info: FrontendDownloadBundleApi$GetInfoForTokenInfo | null;
}

export interface FrontendDownloadBundleApi$GetInfoForTokenInfo {
    description: string;
    expired: boolean;
    expiresAt: string;
    name: string;
}

export interface FrontendFilesApi$FileResult {
    filename: string;
    id: number;
    mediaType: string;
}

export interface FrontendFilesApi$FilesForAssetPageComponentDto {
    hiddenByProtection: boolean;
    tree: FrontendFilesApi$TreeOfFileResult[];
}

export interface FrontendFilesApi$SearchHit {
    componentId: number;
    fileId: number;
    filename: string;
    folderPath: string;
    mediaType: string;
}

export interface FrontendFilesApi$SearchResult {
    hits: FrontendFilesApi$SearchHit[];
    truncated: boolean;
}

export interface FrontendFilesApi$TreeOfFileResult {
    children: FrontendFilesApi$TreeOfFileResult[];
    meta: FrontendFilesApi$FileResult | null;
    name: string;
}
export const AdmFilemanagerApi2 = {
  aiEnableFile: (orgId:number,fileId:number,input:AdmFilemanagerApi2$RagFileEnable) : Promise<void> => {
    return JsonApi.put("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/enable_ai_file/{fileId}?fileId="+ ( fileId == null ? "" : fileId ) +"",input)
  },
  aiEnableFolder: (orgId:number,folderId:number,input:AdmFilemanagerApi2$AiServiceFolderEnable) : Promise<void> => {
    return JsonApi.put("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/enable_folder_for_ai/{folderId}?folderId="+ ( folderId == null ? "" : folderId ) +"",input)
  },
  createFolder: (orgId:number,parentFolderId:number,input:AdmFilemanagerApi2$CreateFolder) : Promise<AdmFilemanagerApi2$CreateFolderResult> => {
    return JsonApi.post("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/create_folder/" + parentFolderId + "",input)
  },
  deleteFile: (orgId:number,fileId:number) : Promise<void> => {
    return JsonApi.post("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/delete_file/" + fileId + "")
  },
  deleteFolderDeep: (orgId:number,folderId:number) : Promise<void> => {
    return JsonApi.post("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/delete_folder_deep/" + folderId + "")
  },
  download: (orgId:number,fileId:number) : Promise<unknown> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/download/" + fileId + "")
  },
  fileUpload: (orgId:number,folderId:number,files:Array<File>) : Promise<void> => {
    return JsonApi.post_form("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/file_upload/" + folderId + "",{"files": files})
  },
  getAiSupportedFileTypes: (orgId:number) : Promise<AdmFilemanagerApi2$UiAiSupportedFileTypesResult> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/ai_supported_file_types")
  },
  getFileDetails: (orgId:number,fileId:number) : Promise<AdmFilemanagerApi2$UiFileDetails> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/file_details/" + fileId + "")
  },
  getFolderContents: (orgId:number,folderId:number) : Promise<AdmFilemanagerApi2$FolderContents> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/folder_contents/" + folderId + "")
  },
  getFolderOverview: (orgId:number) : Promise<AdmFilemanagerApi2$FolderOverviewResult> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/folder_overview")
  },
  getFolderProtection: (orgId:number,folderId:number) : Promise<AdmFilemanagerApi2$FolderProtectionDetails> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/folder_protection/" + folderId + "")
  },
  getFolderTree: (orgId:number,includeFiles:boolean) : Promise<FilemanagerSharedDefinitions$FoldersAndFilesResult> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/folder_tree?includeFiles="+ ( includeFiles == null ? "" : includeFiles ) +"")
  },
  renameFile: (orgId:number,fileId:number,input:AdmFilemanagerApi2$RenameInput) : Promise<void> => {
    return JsonApi.put("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/rename_file/" + fileId + "",input)
  },
  renameFolder: (orgId:number,folderId:number,input:AdmFilemanagerApi2$RenameInput) : Promise<void> => {
    return JsonApi.put("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/rename_folder/" + folderId + "",input)
  },
  searchFiles: (orgId:number,folderId:number,q:string,filter:AdmFilemanagerApi2$UiFileSearchFilter,limit:number) : Promise<AdmFilemanagerApi2$UiFileSearchResult> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/search_files/" + folderId + "?q="+ ( q == null ? "" : q ) +"&filter="+ ( filter == null ? "" : filter ) +"&limit="+ ( limit == null ? "" : limit ) +"")
  },
  setFileCondition: (orgId:number,fileId:number,input:AdmFilemanagerApi2$UiFileAssetCondition) : Promise<void> => {
    return JsonApi.post("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/set_file_condition?fileId="+ ( fileId == null ? "" : fileId ) +"",input)
  },
  setFolderCondition: (orgId:number,folderId:number,input:AdmFilemanagerApi2$UiFileAssetCondition) : Promise<void> => {
    return JsonApi.post("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/set_folder_condition?folderId="+ ( folderId == null ? "" : folderId ) +"",input)
  },
  setFolderProtection: (orgId:number,folderId:number,input:AdmFilemanagerApi2$FolderProtectionInput) : Promise<void> => {
    return JsonApi.put("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/folder_protection/" + folderId + "",input)
  },
}
export const AdmFilemanagerApiAssets = {
  getFolderTree: (orgId:number,assetId:number) : Promise<FilemanagerSharedDefinitions$FoldersAndFilesResult> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager/assets/folder_structure?assetId="+ ( assetId == null ? "" : assetId ) +"")
  },
}
export const AdmFilemanagerApiSuperadminTools = {
  getTextChunksForFile: (orgId:number,fileId:number) : Promise<AdmFilemanagerApiSuperadminTools$TextChunks> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager/superadmin_tools/get_text_chunks_for_file?fileId="+ ( fileId == null ? "" : fileId ) +"")
  },
}
export const AdmFilemanagerApiTools = {
  bulkCategorySet: (orgId:number,bulkCategorySet:AdmFilemanagerApiTools$BulkCategorySet) : Promise<void> => {
    return JsonApi.post("api/admin/bc/asset_files/org/" + orgId + "/filemanager/tools/bulk_category_set",bulkCategorySet)
  },
}
export const AdmFilemanagerOptionsApi = {
  getI18nVariantFamilies: (orgId:number) : Promise<Array<string>> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager/options/i18n_variant_families")
  },
  getSelectableCategories: (orgId:number) : Promise<Array<string>> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager/options/selectable_categories")
  },
  setDetails: (orgId:number,fileId:number,input:AdmFilemanagerOptionsApi$SetFileOptions) : Promise<void> => {
    return JsonApi.put("api/admin/bc/asset_files/org/" + orgId + "/filemanager/options/" + fileId + "",input)
  },
}
export const AdmToolsAssetFilesTmpDownloadLinkApi = {
  create: (orgId:number,input:AdmToolsAssetFilesTmpDownloadLinkApi$CreateDownloadLinkInput) : Promise<void> => {
    return JsonApi.post("api/admin/bc/asset_files/org/" + orgId + "/tools/create_asset_temp_download_link",input)
  },
  getHistory: (orgId:number) : Promise<Array<AdmToolsAssetFilesTmpDownloadLinkApi$HistoryEntry>> => {
    return JsonApi.get("api/admin/bc/asset_files/org/" + orgId + "/tools/create_asset_temp_download_link/history")
  },
}
export const CpCstlnDataApi = {
  get: (orgId:number) : Promise<CpCstlnDataApi$GetInfo> => {
    return JsonApi.get("api/admin/bc/asset_files/controlpanel/cstln_data/organisation/" + orgId + "")
  },
  getOrganisations: () : Promise<CpCstlnDataApi$GetOrganisations> => {
    return JsonApi.get("api/admin/bc/asset_files/controlpanel/cstln_data/organisations")
  },
  getTranscriptionTools: (orgId:number) : Promise<CpCstlnDataApi$TranscriptionToolsInfo> => {
    return JsonApi.get("api/admin/bc/asset_files/controlpanel/cstln_data/organisation/" + orgId + "/transcription_tools")
  },
  save: (orgId:number,input:CpCstlnDataApi$SaveInfo) : Promise<void> => {
    return JsonApi.post("api/admin/bc/asset_files/controlpanel/cstln_data/organisation/" + orgId + "",input)
  },
  testConnection: (orgId:number,input:CpCstlnDataApi$TestConnectionInput) : Promise<CpCstlnDataApi$TestConnectionResult> => {
    return JsonApi.post("api/admin/bc/asset_files/controlpanel/cstln_data/organisation/" + orgId + "/test_connection",input)
  },
}

export const FrontendDownloadBundleApi = {
  download: (token:string) : Promise<unknown> => {
    return JsonApi.get("public-api/bc/asset_files/internal/frontend/download_bundle/download?token="+ ( token == null ? "" : token ) +"")
  },
  getInfoForToken: (token:string) : Promise<FrontendDownloadBundleApi$GetInfoForToken> => {
    return JsonApi.get("public-api/bc/asset_files/internal/frontend/download_bundle?token="+ ( token == null ? "" : token ) +"")
  },
}
export const FrontendFilesApi = {
  getFilesForAssetPageComponent: (organisationId:number,assetPageComponentId:number,viewId:number,viewValue:string,assetId:number) : Promise<FrontendFilesApi$FilesForAssetPageComponentDto> => {
    return JsonApi.get("public-api/asset_frontend/bc/asset_files/" + organisationId + "/files/" + assetPageComponentId + "?viewId="+ ( viewId == null ? "" : viewId ) +"&viewValue="+ ( viewValue == null ? "" : viewValue ) +"&assetId="+ ( assetId == null ? "" : assetId ) +"")
  },
  searchFiles: (organisationId:number,viewId:number,viewValue:string,assetId:number,q:string) : Promise<FrontendFilesApi$SearchResult> => {
    return JsonApi.get("public-api/asset_frontend/bc/asset_files/" + organisationId + "/files/search?viewId="+ ( viewId == null ? "" : viewId ) +"&viewValue="+ ( viewValue == null ? "" : viewValue ) +"&assetId="+ ( assetId == null ? "" : assetId ) +"&q="+ ( q == null ? "" : q ) +"")
  },
}
